<template>
    <div class="report__page">
        <h2>Report Details</h2>
        <ReportDetailsSelector v-if="isLocationReport" :details="customDetailsLocations" :is-compact="true" />
        <ReportDetailsSelector v-else :details="customDetailsAssets" :is-compact="true" />
        <!-- LAST MAINTAINED / ATTENDED LOG -->
    </div>
</template>

<script>
import ReportDetailsSelector from './ReportDetailsSelector.vue';

export default {
    components: {
        ReportDetailsSelector
    },

    data() {
        return {
            customDetailsLocations: [
                { value: 'site_name', label: 'Site' },
                { value: 'asset_id', label: 'ID' },
                { value: 'name', label: 'Name' },
                { value: 'asset_type', label: 'Type' },
                { value: 'location_reference', label: 'Location Reference' },
                { value: 'area', label: 'Area' },
                { value: 'location', label: 'Sub Area' },
                { value: 'description', label: 'Description' },
                { value: 'additional_info', label: 'Additional Info' },
                { value: 'fault_status_asset', label: 'Overall Fault Status' },
                { value: 'fault_id', label: 'Fault ID' },
                { value: 'fault_reporter_name', label: 'Raised by Name' },
                { value: 'fault_reporter_company', label: 'Raised by Company' },
                { value: 'fault_report_note', label: 'Notes' },
                { value: 'fault_status_timestamp', label: 'Created At' },
                { value: 'last_updated_timestamp', label: 'Updated At' },
                { value: 'fault_status', label: 'Fault Status' }
            ],
            customDetailsAssets: [
                { value: 'site_name', label: 'Site' },
                { value: 'asset_id', label: 'ID' },
                { value: 'name', label: 'Name' },
                { value: 'asset_type', label: 'Type' },
                { value: 'area', label: 'Area' },
                { value: 'location', label: 'Sub Area' },
                { value: 'description', label: 'Description' },
                { value: 'install_date', label: 'Install Date' },
                { value: 'maintenance_schedule_start_date', label: 'Maintenance Schedule Start Date' },
                { value: 'fault_status_asset', label: 'Overall Fault Status' },
                { value: 'fault_id', label: 'Fault ID' },
                { value: 'fault_reporter_name', label: 'Raised by Name' },
                { value: 'fault_reporter_company', label: 'Raised by Company' },
                { value: 'fault_report_note', label: 'Notes' },
                { value: 'fault_status_timestamp', label: 'Created At' },
                { value: 'last_updated_timestamp', label: 'Updated At' },
                { value: 'fault_status', label: 'Fault Status' }
            ]
        }
    },

    computed: {
        isLocationReport() {
            return this.$store.getters['createCustomReport/getMaintenanceSelectedAssetType'] === 'Location'
        }
    }
}
</script>

<style lang="scss" scoped>
.report__page {
    height: 100%;
    padding: 0.5rem;

    h2 {
        padding-left: 1rem;
        margin: 0;
    }
}
</style>